import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { ROLE_NAME, RSP_ROLES } from 'src/app/shared/enums/admin-enum';
import { RoleService } from './../../../../../../shared/service/role.service';

export const ROLE = [
  {
    value: 'SUPER_USER',
    name: 'Super User'
  },
  {
    value: 'OPERATOR_ACCESS',
    name: 'Access Management'
  },
  {
    value: 'OPERATOR_INFO',
    name: 'Portal Information'
  },
  {
    value: 'GE_TAG_ID_ADMIN',
    name: 'GE Tag ID Admin'
  },
  {
    value: RSP_ROLES.EOL_ADMIN,
    name: ROLE_NAME.EOL_ADMIN,
  },
];


@Component({
  selector: 'app-create-edit-role',
  templateUrl: './create-edit-role.component.html',
  styleUrls: ['./create-edit-role.component.scss']
})
export class CreateEditRoleComponent implements OnInit {

  roleForm: FormGroup;
  isEdit = false;
  roles = ROLE;
  id: number;
  constructor(
    private spinner: Spinner,
    private activatedRoute: ActivatedRoute,
    private roleService: RoleService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.getUserById(res.id);
        this.isEdit = true;
      }
    });
   }

  ngOnInit() {
    this.initForm();
  }

  public getUserById(id) {
    this.spinner.show();
    this.roleService.getUserById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        const model = {
          sso: res.data.sso,
          fullName: res.data.fullName,
          email: res.data.email,
          roles: res.data.roles[0]
        };
        this.id = res.data.id;
        this.initForm(model);
      }
    });
  }

  public initForm(model?) {
    if (model) {
      this.roleForm = new FormGroup({
        sso: new FormControl(model.sso, [CustomValidator.required]),
        fullName: new FormControl(model.fullName),
        email: new FormControl(model.email),
        roles: new FormControl(model.roles, [CustomValidator.required])
      });
    } else {
      this.roleForm = new FormGroup({
        sso: new FormControl('', [CustomValidator.required]),
        fullName: new FormControl(),
        email: new FormControl(),
        roles: new FormControl('', [CustomValidator.required])
      });
    }
  }

  search() {
    this.spinner.show();
    this.roleService.checkSSO(this.roleForm.controls.sso.value).subscribe(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.roleForm.controls.fullName.setValue(res.data[0].fullName);
        this.roleForm.controls.email.setValue(res.data[0].email);
      } else {
        this.toastr.error(MESSAGE_TOAST.SSO_NOT_FOUND);
        this.roleForm.controls.sso.setValue('');
        this.roleForm.controls.fullName.setValue('');
        this.roleForm.controls.email.setValue('');
      }
    });
  }

  save() {
    if (this.roleForm.invalid) {
      this.markFormGroupTouched(this.roleForm);
      return;
    }
    const model = {
      id: this.id,
      sso: this.roleForm.controls.sso.value,
      email: this.roleForm.controls.email.value,
      fullName: this.roleForm.controls.fullName.value,
      roles: [this.roleForm.controls.roles.value]
    };
    this.spinner.show();
    if (this.isEdit) {
      this.roleService.updateRole(model).subscribe(res => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.UPDATE_ROLES);
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ROLES]);
      });
    } else {
      this.roleService.addRole(model).subscribe(res => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.ADD_ROLES);
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ROLES]);
      });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
